export default {
  FETCH_CLASS_YEARS_START: 'FETCH_CLASS_YEARS_START',
  FETCH_CLASS_YEARS_SUCCESS: 'FETCH_CLASS_YEARS_SUCCESS',
  FETCH_CLASS_YEARS_FAILURE: 'FETCH_CLASS_YEARS_FAILURE',
}
